import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import ApiCallServices from "../../../../services/ApiCallServices"
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import DealsTable from "./child/DealsTable"
import button from "../../../button.module.css"
import { useLocation } from 'react-router-dom';

const initialDeal = {
    deal_code: '',
    deal_name: ''
}

const dealTypeOption = [
    { id: 0, name: "All" },
   { id: 1, name: "New Deal Added in selected range" },
    { id: 2, name: "New Deleted Deal" }
  ];

const formatDateString = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getDefaultDates = () => {
    const today = new Date();
    const firstDate = new Date(today);
    const secondDate = new Date(today);

    firstDate.setDate(today.getDate() - 3);
    secondDate.setDate(today.getDate() - 2);

    return {
        firstDate: formatDateString(firstDate),
        secondDate: formatDateString(secondDate)
    };
};

const formatCost = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    const amount = Number(value);
    if (Number.isNaN(amount)) return '-';
    return amount.toLocaleString('en-US', {
        currency: 'USD',
        currencyDisplay: 'symbol',
        style: 'currency',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
  
const CompareDeal = () => {
    const selectControlStyles = {
        control: (provided) => ({ ...provided, minHeight: '30px', height: '30px' }),
        valueContainer: (provided) => ({ ...provided, padding: '0 6px' }),
        indicatorsContainer: (provided) => ({ ...provided, height: '30px' }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 })
    };
    const [tableData, setTableData] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedPartner, setSelectedPartner] = useState(null)
    const [partnerList, setPartnerList] = useState([])
    const [demandList, setDemandList] = useState([])
    const [selectedDemand, setSelectedDemand] = useState()
    const [selectedDemandPartner, setSelectedDemandPartner] = useState(null)
    const [newDeal, setNewDeal] = useState(initialDeal);
    const [filterPartner, setFilterPartner] = useState()
    const [errors, setErrors] = useState({})

    const [selectedNewDemand, setSelectedNewDemand] = useState()
    const defaultDates = getDefaultDates();
    const [firstDate, setFirstDate] = useState(defaultDates.firstDate)
    const [secondDate, setSecondDate] = useState(defaultDates.secondDate)
    const [selectedDeal, setSelectedDeal] = useState(null)
    const [showDetailModal, setShowDetailModal] = useState(false)

    const [sortingColumn, setSortingColumn] = useState(null);
    const [sortingOrder, setSortingOrder] = useState('asc');

    const [showHideModal, setShowHideModal] = useState(false)

    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const isNavigatedFromSupplyPartner = useRef(false);
    const [agencyList, setAgencyList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [countryList, setCountryList] = useState([])

    
    

    useEffect(() => {
        if (location.state && location.state.id && location.state.name) {
            isNavigatedFromSupplyPartner.current = true;
            setFilterPartner({ id: location.state.id, name: location.state.name });
        }
    }, [location.state]);

    useEffect(() => {
        if (isNavigatedFromSupplyPartner.current) {

            if (filterPartner && filterPartner.id) {
                console.log("Fetching deals for navigated client_id:", filterPartner.id);
                getDealsTableData(filterPartner.id);
            }
        } else {
            getDealsTableData()
        }
    }, [filterPartner, search, sortingColumn, sortingOrder, selectedDemand, selectedDemandPartner, firstDate, secondDate]);





    const getDealsTableData = (client_id) => {
        setLoader(true);
        const data = {
            name: search,
            client_id: filterPartner?.id || client_id || '',
            sortingcolumn: sortingColumn,
            sortingorder: sortingOrder,
            deal_type: selectedDemand?.id || '',
            demand_partner_id: selectedDemandPartner?.id || '',
            first_date: firstDate,
            second_date: secondDate
        };

        ApiCallServices.create(END_POINTS.compDealsTableData, data)
            .then(res => {
                if (res.status === 200) {
                    setTableData(res.data.data);
                }
            })
            .catch(error => {
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: 'top-right',
                    });
                }
            })
            .finally(() => setLoader(false));
    };



    const supply = sessionStorage.getItem('sp');
    const supplypartner = JSON.parse(supply);
    console.log(supplypartner, 'supplypartner');

    const handleFirstDateChange = (e) => {
        setFirstDate(e.target.value);
    }

    const handleSecondDateChange = (e) => {
        setSecondDate(e.target.value);
    }

    const handleViewDetail = (deal) => {
        setSelectedDeal(deal);
        setShowDetailModal(true);
    }

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedDeal(null);
    }


    useEffect(() => {
        if (supplypartner) {
            setFilterPartner(supplypartner);
        }
    }, [supplypartner]);





    console.log(filterPartner, "filterPartner")
    const deleteDeal = (id) => {
        ApiCallServices.create(END_POINTS.deleteDeal, { id: id }).then((res) => {
            if (res.status == 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });
    }

    const confirmDelete = (id) => {
        if (window.confirm('Are you sure you want to delete the Deal')) {
            deleteDeal(id);
        }
    }

    const updateDealStatus = (id, status) => {
        ApiCallServices.create(END_POINTS.updateDealStatus, { id: id, status: status }).then((res) => {
            if (res.status == 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }

        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    const confirmUpdate = (id, status) => {
        if (window.confirm('Are you sure you want to Update the status')) {
            updateDealStatus(id, status);
        }
    }

    const searchDeal = (e) => {
        if (e.target.value.length > 1) {
            setSearch(e.target.value);
        } else {
            setSearch('');
        }
    }

    const handleSelectChange = (selectedValue) => {
        setSelectedPartner(selectedValue);
    }

    const handleSort = (column) => {
        if (sortingColumn === column) {
            setSortingOrder(sortingOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortingColumn(column);
            setSortingOrder('asc');
        }
    };

    const getPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.partnerList).then((res) => {
            if (res.status == 200) {
                setPartnerList(res.data.data);
                setSelectedPartner(res.data.data[0])
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });
    }

    useEffect(() => {
        getPartnerList();
    }, [])

    const partnerFilterOptions = [{ id: '', name: 'All' }, ...partnerList];
    const demandPartnerFilterOptions = [{ id: '', name: 'All' }, ...demandList];
    const handleInputChange = (e) => {
        setNewDeal({ ...newDeal, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        //validation
        const validationError = {}

        if (!newDeal?.deal_code) {
            validationError.deal_code = "Deal id is required"
        }
        if (!newDeal?.deal_name) {
            validationError.deal_name = "Deal name is required"
        }
        if (!selectedPartner) {
            validationError.selectedPartner = "Please select supply partner"
        }
        setErrors(validationError)

        if (Object.keys(validationError).length === 0) {
            const obj = {
                deal_code: newDeal.deal_code,
                deal_name: newDeal.deal_name,
                supply_partner: selectedPartner.id,
                demand_partner_id: selectedNewDemand?.id || null
            }
            ApiCallServices.create(END_POINTS.createDeal, obj).then((res) => {
                if (res.status == 200) {
                    toast.success(res.data.message, {
                        position: "top-right"
                    });
                    setNewDeal(initialDeal);
                    setSelectedPartner(partnerList[0])
                    document?.body?.removeAttribute('style');
                    setShowHideModal(false)
                    getDealsTableData();
                }
            })
                .catch((error) => {
                    // Handle errors here
                    if (error.response) {
                        toast.error(error.response.data.error, {
                            position: "top-right"
                        });
                        console.log(error.response, "===>error in getting response");
                    }
                });
        }


    }

    const handleFormReset = () => {
        setNewDeal(initialDeal);
        setShowHideModal(false)
        document?.body?.removeAttribute('style');
        setErrors({})

    }
    const patnerFilterChange = (value) => {
        const selectedValue = value?.id ? value : null;
        if (selectedValue) {
            isNavigatedFromSupplyPartner.current = false;
            setFilterPartner(value);
        } else {
            isNavigatedFromSupplyPartner.current = false;
            setFilterPartner(null);
            getDealsTableData('');
        }
    };

    const handleHideShowModal = () => {
        setShowHideModal(true)
        document.body.style = 'overflow: hidden'
    }

    const getDemandPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.demandPartnerList).then((res) => {
            console.log(res)
            if (res.status == 200) {
                setDemandList(res.data.data)
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    console.log(demandList, "DEMAND((((***")
    useEffect(() => {
        getDemandPartnerList()
    }, [])

    const demandFilterChange = (value) => {
        setSelectedDemand(value)
    }

    const handleDemandPartnerFilterChange = (value) => {
        setSelectedDemandPartner(value?.id ? value : null)
    }

    const handleNewDemandChange = (value) => {
        setSelectedNewDemand(value)
    }

    const mapDemandPartner = (val, dealId) => {
        let data = {
            demand_partner_id: val?.id,
            deal_id: dealId,
        }
        ApiCallServices.create(END_POINTS.mapDealDemandFromTable, data).then((res) => {
            if (res.status == 200) {
                // getDealsTableData()
                toast.success(res.data.message, {
                    position: "top-right"
                });
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    const getAgencyList = () => {
        let data = {

        }
        ApiCallServices.create(END_POINTS.agencyList, data).then((res) => {
            if (res.status === 200) {
                setAgencyList(res.data.data)
            }
        })
    }

    const getBrandList = () => {
        let data = {

        }
        ApiCallServices.create(END_POINTS.brandList, data).then((res) => {
            if (res.status === 200) {
                setBrandList(res.data.data)
            }
        })
    }


    const getCountryList = () => {
        let data = {

        }
        ApiCallServices.getlisting(END_POINTS.countryList, data).then((res) => {
            if (res.status === 200) {
                setCountryList(res.data.data)
            }
        })
    }

    useEffect(() => {
        getAgencyList();
        getBrandList();
        getCountryList();
    }, [])

    const mapAgency = (val, dealId) => {
        let data = {
            agency_id: val?.id,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapAgency, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                // getDealsTableData()
                console.log(res)
            }
        })
    }

    const mapBrand = (val, dealId) => {
        let data = {
            brand_id: val?.id,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapBrand, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                // getDealsTableData()
                console.log(res)
            }
        })
    }

    const mapCountry = (val, dealId) => {
        let data = {
            ccode: val?.ccode,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapCountry, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                console.log(res)
            }
        })
    }

    console.log(agencyList, "***agencyList")

    return (
        <>
            <ToastContainer />
            <div className="container-fluid compare-deal-page">
                <div className='filter-wraper justify-content-between'>
                    <div className='d-flex align-items-center fields'>
                        <h3>Compare Deals</h3>
                    </div>
                </div>

                <div className='filter-wraper justify-content-between compare-deal-filters'>
                    <div className='d-flex align-items-center fields'>
                        <div className='form-group search-icon me-3'>
                            <input type='text' className='form-control' onChange={searchDeal} placeholder='Search by partner & deal' />
                        </div>
                        
                        <div className="form-group custome-select me-3">
                            <Select
                                placeholder="Select Supply Partner"
                                isClearable={false}
                                value={partnerFilterOptions.find((partner) => partner.id === filterPartner?.id) || null}
                                onChange={patnerFilterChange}
                                options={partnerFilterOptions}
                                getOptionLabel={(partner) => partner.name}
                                getOptionValue={(partner) => partner.id}
                                styles={selectControlStyles}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition={'fixed'}
                            />
                        </div>

                        <div className="form-group custome-select me-3">
                            <Select
                                placeholder="Select Demand Partner"
                                isClearable={false}
                                value={demandPartnerFilterOptions.find((demand) => demand.id === selectedDemandPartner?.id) || null}
                                onChange={handleDemandPartnerFilterChange}
                                options={demandPartnerFilterOptions}
                                getOptionLabel={(demand) => demand.name}
                                getOptionValue={(demand) => demand.id}
                                styles={selectControlStyles}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition={'fixed'}
                            />
                        </div>

                        {/*} <div className="form-group custome-select me-3">
                            <Select
                                placeholder="Select Deal Type"
                                isClearable={false}
                                value={dealTypeOption.find(d => d.id === selectedDemand?.id) || null}
                                onChange={demandFilterChange}
                                options={dealTypeOption}
                                getOptionLabel={(opt) => opt.name}
                                getOptionValue={(opt) => opt.id}
                                styles={selectControlStyles}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition={'fixed'}
                            />
                        </div>
                        */}


                        <div className='form-group date-field me-3'>
                            <input type='date' className='form-control' value={firstDate} onChange={handleFirstDateChange} />
                        </div>
                        <div className='form-group date-field me-3'>
                            <input type='date' className='form-control' value={secondDate} onChange={handleSecondDateChange} />
                        </div>
                    </div>
                    <div className='form-group d-flex justify-content-end'>
                        {/* <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} data-bs-toggle="modal" data-bs-target="#mapDealClient">Map Deal</button> */}
                        {/* <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} onClick={handleHideShowModal}>Add New Deal</button> */}
                    </div>
                </div>

                <DealsTable
                    tableData={tableData}
                    onSort={handleSort}
                    loader={loader}
                    onViewDetail={handleViewDetail}
                    firstDate={firstDate}
                    secondDate={secondDate}
                />
            </div>

            {/* add new deal */}
            <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add New Deal</h4>
                            <i className="fa-regular fa-circle-xmark close-icon" onClick={handleFormReset}></i>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-wraper">
                                    <div className="form-group custome-select">
                                        <label>Supply Partner <span className="astric">*</span></label>
                                        <Select
                                            value={selectedPartner}
                                            onChange={handleSelectChange}
                                            options={partnerList}
                                            defaultValue={partnerList[0]}
                                            getOptionLabel={(partnerList) => partnerList.name}
                                            getOptionValue={(partnerList) => partnerList.id}
                                            styles={selectControlStyles}
                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                            menuPosition={'fixed'}
                                        />
                                        {errors.selectedPartner && <div className='input-error'>{errors.selectedPartner}</div>}
                                    </div>
                                    <div className="form-group custome-select">
                                        <label>Demand Partner</label>
                                        <Select
                                            placeholder="Select Demand Partner"
                                            value={selectedNewDemand}
                                            onChange={handleNewDemandChange}
                                            options={demandList}
                                            defaultValue={demandList[0]}
                                            getOptionLabel={(demandList) => demandList.name}
                                            getOptionValue={(demandList) => demandList.id}
                                            styles={selectControlStyles}
                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                            menuPosition={'fixed'}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Deal Code <span className="astric">*</span></label>
                                        <input type="text" placeholder="Deal Id" value={newDeal.deal_code} name="deal_code" onChange={handleInputChange} className="form-control" />
                                        {errors.deal_code && <div className='input-error'>{errors.deal_code}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Deal Name <span className="astric">*</span></label>
                                        <input type="text" placeholder="Enter Deal Name" value={newDeal.deal_name} name="deal_name" onChange={handleInputChange} className="form-control" />
                                        {errors.deal_name && <div className='input-error'>{errors.deal_name}</div>}
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className={`${button.btn} ${button.btnBlue}`}>Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showDetailModal && selectedDeal && (
                <div className="modal form-modal show d-block" style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                    <div className="modal-dialog modal-lg" style={{margin: 'auto'}}>
                        <div className="modal-content" style={{borderRadius: '8px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)', border: 'none'}}>
                            <div className="modal-header" style={{borderBottom: '1px solid #e9ecef', backgroundColor: '#f8f9fa', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}>
                                <h4 className="modal-title" style={{fontWeight: '600', color: '#212529'}}>Deal Details</h4>
                                <button type="button" className="btn-close" onClick={handleCloseDetailModal} aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{padding: '2rem'}}>
                                <div className="row g-4">
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Supply Partner</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{selectedDeal.supply_partner_name || '-'}</div>
                                    </div>
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Demand Partner</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{selectedDeal.demand_partner_name || '-'}</div>
                                    </div>
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Country</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{selectedDeal.country || '-'}</div>
                                    </div>
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Deal Name</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{selectedDeal.deal_name || '-'}</div>
                                    </div>
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Adv Cost ({firstDate || 'First Date'})</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{formatCost(selectedDeal.adv_cost_first_date ?? selectedDeal.first_revenue)}</div>
                                    </div>
                                    <div className="col-md-6" style={{paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0'}}>
                                        <div className="small text-muted" style={{fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500'}}>Adv Cost ({secondDate || 'Second Date'})</div>
                                        <div style={{fontSize: '1rem', fontWeight: '600', color: '#212529'}}>{formatCost(selectedDeal.adv_cost_second_date ?? selectedDeal.second_revenue)}</div>
                                    </div>
                                </div>

                                <div style={{marginTop: '2rem', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '10px', padding: '1rem 1.25rem'}}>
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap'}}>
                                        <h5 style={{fontWeight: '600', marginBottom: '0', color: '#212529'}}>Last 30 Days Advertiser Cost</h5>
                                        <div style={{display: 'flex', gap: '0.75rem', flexWrap: 'wrap'}}>
                                            {(() => {
                                                const history = (selectedDeal.last_30_days_advertiser_revenue || selectedDeal.daily_spend || [])
                                                    .map((row) => ({
                                                        date: row.date || row.Date || row.day || row.created_at || '-',
                                                        amount: row.advertiser_cost ?? row.spend ?? row.amount ?? row.cost ?? null,
                                                    }))
                                                    .filter((row) => row.amount !== null && row.amount !== undefined);

                                                const validAmounts = history.map((row) => Number(row.amount)).filter((value) => !Number.isNaN(value));
                                                const latest = validAmounts.length ? validAmounts[0] : null;
                                                const total = validAmounts.reduce((sum, value) => sum + value, 0);
                                                const average = validAmounts.length ? total / validAmounts.length : null;

                                                return (
                                                    <>
                                                        <div style={{backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '8px', padding: '0.5rem 0.75rem', minWidth: '110px'}}>
                                                            <div style={{fontSize: '0.75rem', color: '#6c757d', fontWeight: '600'}}>Latest</div>
                                                            <div style={{fontSize: '0.95rem', fontWeight: '700', color: '#212529'}}>{formatCost(latest)}</div>
                                                        </div>
                                                        <div style={{backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '8px', padding: '0.5rem 0.75rem', minWidth: '110px'}}>
                                                            <div style={{fontSize: '0.75rem', color: '#6c757d', fontWeight: '600'}}>Average</div>
                                                            <div style={{fontSize: '0.95rem', fontWeight: '700', color: '#212529'}}>{formatCost(average)}</div>
                                                        </div>
                                                        <div style={{backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '8px', padding: '0.5rem 0.75rem', minWidth: '110px'}}>
                                                            <div style={{fontSize: '0.75rem', color: '#6c757d', fontWeight: '600'}}>Total</div>
                                                            <div style={{fontSize: '0.95rem', fontWeight: '700', color: '#212529'}}>{formatCost(total)}</div>
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>

                                    {(selectedDeal.last_30_days_advertiser_revenue || selectedDeal.daily_spend) && (selectedDeal.last_30_days_advertiser_revenue || selectedDeal.daily_spend).length > 0 ? (
                                        <div className="table-responsive mt-3">
                                            <table className="table table-bordered" style={{marginBottom: '0', borderCollapse: 'collapse'}}>
                                                <thead style={{backgroundColor: '#fff'}}>
                                                    <tr>
                                                        <th style={{borderBottom: '2px solid #dee2e6', fontWeight: '600', color: '#212529', padding: '0.75rem'}}>Date</th>
                                                        <th style={{borderBottom: '2px solid #dee2e6', fontWeight: '600', color: '#212529', padding: '0.75rem'}}>Advertiser Cost (USD)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(selectedDeal.last_30_days_advertiser_revenue || selectedDeal.daily_spend || []).map((row, index) => {
                                                        const dateValue = row.date || row.Date || row.day || row.created_at || '-';
                                                        const amountValue = row.advertiser_cost ?? row.spend ?? row.amount ?? row.cost ?? null;
                                                        return (
                                                            <tr key={`${dateValue}-${index}`} style={{backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                                                <td style={{padding: '0.75rem', borderColor: '#dee2e6'}}>{dateValue}</td>
                                                                <td style={{padding: '0.75rem', borderColor: '#dee2e6'}}>{formatCost(amountValue)}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <p style={{color: '#6c757d', fontStyle: 'italic', marginTop: '1rem', marginBottom: '0'}}>No advertiser cost history available for this deal.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={`${showHideModal ? 'overlay' : ''}`}></div>
        </>
    );
}

export default CompareDeal;